(function () {
  class WinlineAnimator {
    constructor() {
      this.WINLINE_ANIMATION_TIME = 700;
      this.ended = false;
      this.winlineFinished = false;
      this.winlinesPlaying = false;
      this.fullWinAmount = 0;
      this.winlineContainer = undefined;
      this.cellPositions = [];
      this.particleEmitterPool = [];

      this.winlineWidth = 181 * gameData.numReels;

      this._updateFunctor = this.update.bind(this);

      Reflex.registerEventHandler('ready', this.onLayoutComplete.bind(this));

      messageBus.subscribe('spinner:WinningLinesEvent', this.doPayWins.bind(this));
    }

    begin() {
      this.ended = false;
    }

    end() {
      this.ended = true;
    }

    playAnimation(sequence, callback) {
      this.playAnimations([sequence], callback);
    }

    playAnimations(sequence, callback) {
      this.winAmount = sequence[0].winAmount;
      this.callback = callback;
      this.winlineFinished = false;
      this.currentWinlineAnimations = [];
      let self = this;

      if (sequence.length > this.particleEmitterPool.length) {
        const needed = sequence.length - this.particleEmitterPool.length;
        for (let i = 0; i < needed; ++i) {
          const particles = particleManager.createEmitter('winline', 'winlinesContainerFront', 710, 350, false);
          particles.particleEmitter.emit = false;
          this.particleEmitterPool.push(particles);
        }
      }

      sequence.forEach(function (seq, i) {
        const winlineId = seq.winningLine - 1;
        self.currentWinlineAnimations.push({
          winlineId,
          particles: self.particleEmitterPool[i],
          length: seq.occurrences,
        });
      });
      this.startWinline();
    }

    startWinline() {
      if (!this.winlinesPlaying) {
        this.winlinesPlaying = true;
        let self = this;
        this.currentWinlineAnimations.forEach(function (animData) {
          animData.particles.particleEmitter.spawnPos.x = self.getWinlinePointX(0);
          animData.particles.particleEmitter.spawnPos.y = self.getWinlinePointY(animData.winlineId, 0);
          animData.particles.particleEmitter.emit = true;
          animData.particles.visible = true;
        });

        this.animationTime = 0;
        this.totalAnimationTime = this.WINLINE_ANIMATION_TIME;
        if (checkForDefined(this.maxTime)) {
          this.totalAnimationTime = Math.min(this.maxTime, this.totalAnimationTime);
        }
        Reflex.addToUpdate(this._updateFunctor);
      }
    }

    showStaticWinline(sequence) {
      let self = this;
      this.clearWinlines();
      sequence.forEach(function (seq, i) {
        const winlineId = seq.winningLine - 1;
        self.drawWinline({ winlineId, length: seq.occurrences });
      });
    }

    drawWinline(animData) {
      let points = this.getPointsForWinline(animData);

      for (let line = 0; line < 1; line++) {
        let colour = 0xff0000 + (Math.min(255, 35 * line) << 8) + 5 * line;
        this.winlineContainer.lineStyle(5 - line * 5, colour, 0.5);
        this.winlineContainer.moveTo(points[0].x, points[0].y);
        for (let i = 1; i < points.length; ++i) {
          this.winlineContainer.lineTo(points[i].x, points[i].y);
        }
      }
    }

    getPointsForWinline(animData) {
      let points = [];

      let firstCell = { reel: 0, row: this.spots[animData.winlineId][0] };
      let firstCellPosition = this.cellPositions[firstCell.reel][firstCell.row];
      // on the reelcage, lefthand side
      let leftmostPoint = {
        x: firstCellPosition.x - this.symbolWidth / 2,
        y: firstCellPosition.y,
      };

      points.push(leftmostPoint);
      points.push(firstCellPosition);
      for (let reel = 1; reel < gameData.NUM_REELS; ++reel) {
        let row = this.spots[animData.winlineId][reel];
        let cellPoint = this.cellPositions[reel][row];
        points.push(cellPoint);
      }

      // on the reelcage, righthand side
      let rightmostPoint = {
        x: points[points.length - 1].x + this.symbolWidth / 2,
        y: points[points.length - 1].y,
      };

      points.push(rightmostPoint);
      return points;
    }

    getWinlinePointX = function (progress) {
      // Gets the X point position on a winline.
      // Progress is 0 to 5(far left touching winline box = 0, 0.5 = first reel center, 4.5 = last reel center, 5 = touching right of cage)
      return this.winlineWidth * (progress - 0.5);
    };

    getWinlinePointY = function (winline, progress) {
      // Gets the Y point position on a winline.
      // Progress is 0 to 5(far left touching winline box = 0, 0.5 = first reel center, 4.5 = last reel center, 5 = touching right of cage)

      const height = gameData.appertureSize;
      const offset = gameData.symbolHeight * -1.5;
      progress *= 5;

      if (progress < 0.5) {
        // First half section
        return height * this.spots[winline][0] + offset;
      } else if (progress < 4.5) {
        // Between the five reel centers
        var reel = Math.floor(progress - 0.5);

        var remainingProgress = progress - reel - 0.5;
        var y1 = height * this.spots[winline][reel];
        var y2 = height * this.spots[winline][reel + 1];

        return y1 + (y2 - y1) * remainingProgress + offset;
      } else {
        // Last right half section
        return height * this.spots[winline][gameData.LAST_REEL_INDEX] + offset;
      }
    };

    skipAnimation() {
      if (this.currentWinlineAnimations !== undefined) {
        this.winlinesPlaying = false;
        this.endAnimation();
        this.clearWinlines();
        this.animationTime = this.totalAnimationTime;
      }
    }

    update(delta) {
      this.animationTime += delta;

      if (this.animationTime > this.totalAnimationTime) {
        this.currentWinlineAnimations.forEach(function (animData) {
          animData.particles.particleEmitter.emit = false;
        });
        this.winlinesPlaying = false;
        this.endAnimation();
      } else {
        const p = this.animationTime / this.totalAnimationTime;
        const self = this;
        this.currentWinlineAnimations.forEach(function (animData) {
          const x = self.getWinlinePointX(p);
          const y = self.getWinlinePointY(animData.winlineId, p);

          animData.particles.particleEmitter.spawnPos.x = x;
          animData.particles.particleEmitter.spawnPos.y = y;
        });
      }
    }

    endAnimation() {
      this.currentWinlineAnimations.forEach(function (animData) {
        animData.particles.visible = false;
      });

      this.winlinesPlaying = false;
      Reflex.removeFromUpdate(this._updateFunctor);
      this.finishWinline();
    }

    clearWinlines() {
      if (this.winlineContainer) {
        this.winlineContainer.clear();
      }
    }

    finishWinline() {
      this.winlineFinished = true;
      if (this.callback !== undefined) {
        let cb = this.callback;
        this.callback = undefined;
        cb();
      }
    }

    onGameConfigEvent(gameConfigTask) {
      this.numReels = gameData.NUM_REELS;
      this.numRows = gameData.NUM_ROWS;
      this.numWinlines = gameConfigTask.data.slotConfig.defaultNumLines;

      this.spots = [];
      let winlines = gameConfigTask.data.slotConfig.paylines;
      for (let i = 0; i < winlines.length; i++) {
        this.spots.push(winlines[i].spots);
      }

      this.configurePositions();
    }

    configurePositions() {
      this.symbolWidth = 145;
      this.symbolHeight = 140;

      let slotMachine = resourceManager.getController('SlotMachine');
      for (let reel = 0; reel < this.numReels; ++reel) {
        let reelCells = [];
        for (let row = 0; row < this.numRows; ++row) {
          reelCells.push(slotMachine.getSymbolPosition(reel, row));
        }
        this.cellPositions.push(reelCells);
      }
    }

    drawAllWinlines() {
      for (let i = 0; i < this.numWinlines; ++i) {
        this.drawWinline({ winlineId: i, length: this.numReels });
      }
    }

    onStakeChanged(stake) {
      this.stake = stake;
    }

    onLayoutComplete() {
      this.winlineContainer = resourceManager.get('postReels:winlines');
      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('stake:stakeChanged', this.onStakeChanged.bind(this));
    }

    doPayWins(task) {
      this.fullWinAmount = task.data.totalLineWinnings;
    }
  }

  let create = function () {
    return new WinlineAnimator();
  };
  resourceManager.registerSharedPlugin('WinlineAnimatorEx', create);
})();
